export const USERCONTRACT=`會員服務條款\u000A
歡迎使用本公司會員服務（以下簡稱「本服務」），本服務是由本公司（包含分支機構及關
係企業，以下簡稱「本公司」）所建置的整合性會員服務。為維護您的權益，請於註冊成為
本公司會員前，詳細閱讀下列會員服務條款（以下簡稱「本條款」）。當您完成註冊本公司
會員或使用本服務時，即視為您已經充分閱讀、瞭解並同意接受本條款之所有內容。若您尚
非中華民國民法規定之成年人，需由您的法定代理人（或監護人）閱讀並同意本條款後，方
可註冊使用本服務。 
本公司擁有隨時修改或變更本條款內容的權利並得於本公司官網公告，建議您隨時注意該等
修改或變更。若您於條款修改或變更後繼續使用本服務，即視為您或您的法定代理人（或監
護人）已閱讀、瞭解並同意接受修改或變更後之條款。若您或您的法定代理人（或監護人）
不同意本條款修改及變更方式，或不接受或遵守本條款之任何內容，您應立即停止使用本服
務。 
一、會員註冊 
(一)您可透過本公司網頁、APP、實體門市等管道註冊成為本公司會員，每人限註冊一個會
員帳號，當您註冊會員時，需提供您本人正確、最新及完整資料，並同意本公司得透過包括
但不限於手機門號、身分證字號驗證您的身分，以完整提供本服務。 
(二)完成身分驗證之會員，於符合一定資格下可享有本公司會員權利與服務，本公司會員資
格、權利及服務以本司公告為主。 
二、會員資料 
為使用本服務，您同意以下事項： 
(一)會員註冊時，需提供您本人正確、最新及完整資料。 
(二)當您的個人資料有任何異動時應即時更新，以確保其為正確、最新及完整資料。若您提
供任何錯誤、不實或不完整資料，或原提供的資料已不符合真實，本公司有權暫停或終止您
的帳號，並拒絕您使用本服務之全部或一部分，如因前開情形導致您的權益受損，亦請自行
承擔。 
(三)本公司對您所提供的資料不負查證真偽之責任，如因您登錄不實資料或冒用他人名義以
致侵害他人權利或違法時，應自負相關法律責任；如因此造成本公司損害，您須負賠償之責
任。 
三、會員服務 
(一)本公司確認您註冊會員完成後，將依當時所建置的服務、項目、內容、狀態及功能，對
您提供本服務；本公司保留隨時新增、減少或變更各該服務、項目、內容及功能之全部或一
部之權利，且不另行個別通知。 
(二)當您以本公司會員登入使用各項服務（包括但不限於網站、APP、實體店面系統）時，
個別服務可能另訂有相關使用規範，詳細法律關係、權利、義務等皆依個別服務之規定辦
理，請您自行參閱並遵守個別服務之規定。 
四、會員帳號、密碼及安全 
(一)您有義務妥善保管您的會員帳號、密碼及任何其他可用於會員登入之資訊（以下合稱
「登入資訊」），不得洩漏給任何第三人，以確保其機密性與安全性。 
(二)登入資訊僅限於您個人使用，您不得出租、出借、移轉或讓與給其他第三人使用。無論
是否由本人親自輸入或操作，以登入資訊登入本服務後所進行的一切行為，都將視為您本人
的行為，須負完全的責任。 
(三)如您發現您的登入資訊遭盜用，或被他人不當使用等任何安全問題發生時，您應立即通
知本公司以利本公司採取相關保護措施；但相關保護措施不得解釋為本公司因此而明示或默
示對您負有任何形式之回復原狀、賠償或補償義務。 
(四)當您結束使用本服務後，應確實登出並關閉瀏覽器視窗或應用程式，以防止被他人盜
用。 
五、會員服務： 
(一)預約： 
1. 會員同意預約即應即應收取桌位使用費用。由電子收費系統第三方支付。 
2. 會員同意預約遲到照常收費，不得延長時間。另，需延長時間費用另計，並應於屆
時前2小時再次預訂並再繳費。若未按時預定即視為同意屆時即停止使用該坐位。 
3. 會員同意取消預訂應於預定時間開始前2個小時前取消，未按本規則取消不得要求
退費。若有得退費之情事會員同意以抵用卷方式支付，並同意不以現金退費。


(二)排隊規則： 
1. 客滿時，願意等候及無預約再依現場預約坐位，依預約方式取得時段為準。 
2. 同意以有預約為有優先權力。 
3. 若現場有人排隊時，不得佔用現場空位，確認坐位為預約坐位，並為坐位使用時段
才可使用該坐位。
4. 現場不得占用非約定之坐位影響他人使用、安靜等待。 

(三)使用者的守法義務及承諾 
會員承諾絕不為任何非法目的或以任何非法方式使用本服務，同意本公司服務場地禁止
下列情事之規範： 
1. 禁止賭博或其他賭博性交易。 
2. 禁止現金交易及非法行為。 
3. 未成年請勿在上課時間及晚上10點後逗留。 
4. 禁止破壞場地。 
5. 禁止吸菸、禁止使用毒品。 
6. 除現垃圾外，禁止棄置私人垃圾。
7. 禁止在桌面上灑痱子粉、滑石粉、含相同作用之粉末。
8. 禁止飲用含酒精飲料。 

以上行為一經發現立即停止會員服務。會員同意如有以上情事願意公司依法配
合檢警提供資料供司法單位調查。 
(四)其他約定 
1. 會員同意共同維護使用場域整潔，離開時將桌面清理乾淨。
2. 會員同意共同維持共同使用空間的品質，盡量降低聲量不喧嘩、叫囂。 
3. 會員同意不影響非該桌使用人的使用權利。 
4. 會員同意如有違反本契約內容，縱然時間未到時被請出不得要求退費或補償。如造
成本公司損害會員應負賠償責任。 
5. 會員同意未遵守約定造成共同使用者之干擾、影響時緃未到時本公司有權停止繼續
使用並請使用者之權利，未到時被請出不得要求退費或補償。 
6. 會員同意使用實體店面現場不從事任何非法行為、交易，一經發現同意本公司依法
處理。 
 
(五)個人資料保護及隱私權政策 
本公司依「個人資料保護法」相關規定，蒐集、處理及利用您於本公司會員平臺（以下簡稱
「會員平臺」)及點數平臺登錄、留存之個人資料，並妥善加以保管。以下說明本公司如何
蒐集、處理、利用您的個人資料，以及您有哪些權利可以行使： 
(一)個人資料蒐集之目的 
本公司蒐集個人資料的目的係為確認使用本服務的會員身分、提供本服務、優化本公司現在
或未來服務及其他合於法令目的或主管機關要求之使用，包括：履行契約義務及行使契約權
利、履行法定義務、消費者、客戶管理與服務、消費者保護、信用卡、現金卡、轉帳卡或電
子票證業務、資(通)訊服務/資料庫管理/安全管理、調查、統計與研究分析、廣告或商業行
為管理、傳播行政與管理、票券業務、影視、音樂與媒體管理、網路購物及其他電子商務服
務、行銷、其他諮詢與顧問服務、其他經營合於營業登記項目或組織章程所定之業務及個人
資料之合法交易業務。 
(二)個人資料蒐集之類別 
辨識個人者（例如：姓名、住址、以前地址、住家電話號碼、行動電話、網路平臺申請之帳
號、會員編號、電子郵件地址、網際網路協定IP位址、Cookie及其他任何可辨識資料本人
者等）、辨識財務者（例如：金融機構帳戶之號碼與姓名、電子支付之號碼、信用卡或簽帳
卡之號碼、個人之其他號碼或帳戶等）、政府資料中之辨識者（例如：身分證統一編號、統
一證號、護照號碼等）、個人描述（例如：年齡、性別、出生年月日、出生地、國籍
等））、約定或契約。 (三)個人資料利用期間、地區及對象 
1. 利用期間：本公司將依照本條款所載之個人資料蒐集的特定目的，於本服務營業存續
期間、個別契約有效期間內、法令所定應保存之期間內（包括但不限於民法、個人資
料保護法等）及因執行業務所須之保存期間內（較法令所定期間更長者），持續保
管、處理及利用所蒐集之個人資料。 
2. 利用地區：除法令另有規定外，本公司僅會基於您授權的範圍，於本服務所提供之領
域及地區內，依照服務目的之必要範圍，利用您所提供的個人資料。 
3. 利用對象：本公司或依法有權的政府機關。 
(三)個人資料利用之方式 
我們會以必要的方式利用您的個人資料以達成蒐集目的，例如： 
1. 為您建立客戶／會員檔案以便我們管理帳戶。 
2. 以您的各項聯繫方式與您業務聯繫，或向您通知與本服務有關之資訊。 
3. 以您的各項聯繫方式不定期向您發送本服務公告、提醒，或提供本公司、關係企業或
合作夥伴的行銷資訊，例如優惠方案、促銷活動、市場或使用者調查等。 
4. 分析您的個人資料以優化我們的各項服務。 
5. 分析您的個人資料，並以統計數據、趨勢或其他無法識別您的身分之形式產出結果。 
6. 本公司有可能會查看或提供會員的個人資料或相關電信資料給相關政府機關、或主張
其權利受侵害並提出適當證明之第三人： 
依法令規定、或依司法機關或其他相關政府機關的命令； 
會員涉及違反法令、侵害第三人權益、或違反本使用條款或各該使用規範或約定； 
為保護會員服務系統之安全或經營者之合法權益； 
為保護其他使用者或其他第三人的合法權益； 
為維護本系統的正常運作。 
(四)您可行使之權利 
1. 查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用、
請求刪除。您如欲行使上述權利，可向本公司申請，經一定程序驗證身分後辦理，但
查詢或請求閱覽個人資料或製給複製本者僅提供本人資料不提供含有第三人之資料，
本公司得酌收必要成本費用。 
2. 您得自由選擇是否提供個人資料，惟若拒絕提供，您知悉並同意將無法收到或享有部
分會員優惠權益。 
(五)個人資料之保護 
本公司將依照個人資料保護法令相關規定、隱私權保護政策保護您的個人資料。 
六、暫停及終止服務 
(一)本公司將以合理之方式及技術，維護本服務之正常運作，但如有下列情形之一時，本公
司得不經通知暫停提供本服務之全部或一部： 
1. 對於提供本服務的相關系統設備進行遷移、更換或維護、施工時。 
2. 天災或不可抗力之因素所導致之服務停止、中斷或不能正常運作時。 
3. 非本公司所得控制之事由而致您的服務資訊顯示不正確、或遭偽造、竄改、刪除或擷
取時。 
4. 其他因不可歸責於本公司所造成服務停止或中斷時。 
(二)如有以下情形，本公司得不經通知限制您使用本服務、終止或暫停您的會員資格，並刪
除您的會員帳號及所有以本公司會員登入服務之相關資料，您不得要求恢復原狀： 
您違反政府法令、本契約條款或有其他不當使用、從事非法行為之情形時。 
(三)除本條款另有約定外，您的會員身分係不可轉讓，且您因會員身分所取得之任何權益，
於您死亡時立刻終止。 
七、免責聲明 
(一)若您因違反本條款或相關法令，或侵害其他人之任何權利等一切不法或不當行為，致第
三人、本公司、合作廠商或上開人等之受僱人、受託人、代理人及其他相關履行輔助人受有
損害或支出費用時，您應自負相關法律責任與損害賠償責任。 
(二)基於網際網路特性，本公司就本服務及您經由本公司之服務介面及其連結之其他網站、
APP 而下載的軟體或資料不負任何明示或默示之擔保責任，且不保證本服務之穩定、安全、
無誤及不中斷，您應自行備份本服務相關資料。 
(三)如因本公司相關系統軟硬體設備故障、失靈或人為操作上疏失而致本服務資料傳輸或儲
存上的漏誤、或遭第三人侵入系統篡改偽造資料時，除該事由係因本公司有故意或重大過失
而可歸責於本公司者外，本公司不負相關賠償責任。 
(四)就本服務無償提供部分，本公司對於您使用該服務、或無法使用該服務所致生之任何損
害或不利益，均不負任何賠償責任。 
八、以電子文件為表示方法 
您同意於使用本服務時一切交易之意思表示皆以電子文件作為表示方法，倘您於各項服務與
功能等頁面點選同意或確認等功能鍵時，即視為您正式之意思表示。 
九、準據法及管轄法院 
(一)關於本條款之解釋或適用，以中華民國法律為準據法。 
(二)因使用本服務而與本公司所生之爭議，您同意依誠信原則解決之，如有訴訟之必要時，
除適用民事訴訟法第436-8條小額訴訟之情形外，同意以臺灣臺中地方法院為第一審管轄法
院。 `